import { render } from "./movieCard.vue?vue&type=template&id=309827ae"
import script from "./movieCard.vue?vue&type=script&lang=js"
export * from "./movieCard.vue?vue&type=script&lang=js"

import "./movieCard.vue?vue&type=style&index=0&id=309827ae&lang=scss"

import exportComponent from "/home/runner/work/cinema_vue/cinema_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__